<script setup lang="ts">
import { usePaneStore } from '#layers/chrome/stores/pane';
import ProjectChromeProjectName from './ProjectChromeProjectName.vue';
import ProjectChromeSidebarToggle from './ProjectChromeSidebarToggle.vue';

const paneStore = usePaneStore();
</script>

<template>
	<div class="flex items-center gap-3 pe-3 text-sm font-semibold block-(--primary-header-height)">
		<ProjectChromeProjectName class="grow ps-5" />

		<ProjectChromeSidebarToggle v-if="paneStore.sidebarVisible" class="shrink-0" />
	</div>
</template>
